/* eslint-disable no-new-object */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable camelcase */
/* eslint-disable no-prototype-builtins */
import axios from 'axios';
import { Message } from 'element-ui';
import { uuid } from '@/lib/uuid.js';
import aegis from '@/utils/aegis.js';
import { config } from '@/config/index';
import md5 from 'blueimp-md5';

const pendingMap = new Map();

function ErrorObject(code, message) {
  this.code = code;
  this.message = message;
}

const apiBaseUrl = config.accessApiBaseUrl;

const requestData = {};

const keyInfo = { app_info: { app_id: 'pcgec.eshop.frontend_pc', app_key: '3f402aac-3f8e-4930-8831-613138a499e2' } };

const headers =  {
  'Content-Type': 'application/json;charset=utf-8',
  'trpc-trans-info': `{ "pcgec_access_head": "${window.btoa(JSON.stringify(keyInfo))}" }`,
};

// 如果为测试环境，则注入headers泳道环境的ID
if (process.env.NODE_ENV === 'development') {
  const envID = localStorage.getItem('ESHOP-LANE-ENV-ID') || '';
  if (envID) {
    headers['pcgec-env'] = envID;
  }
}

// create an axios instance
const service = axios.create({
  baseURL: apiBaseUrl, // url = base url + request url
  withCredentials: true, // send cookies when cross-domain requests
  timeout: 10000, // request timeout
  headers,
});

// request interceptor
service.interceptors.request.use(
  (config) => {
    config = setOptions(config);
    if (config.disableRepeatRequest) {
      removePending(config);
      addPending(config);
    }
    requestData[getPendingKey(config)] = {
      ...config,
    };
    return config;
  }

  // do something before request is sent
  ,
  error =>
    // do something with request error
    Promise.reject(error)
);

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  (response) => {
    const { url, data } = requestData[getPendingKey(response.config)];
    try {
      const autoErrorTips = response.config.autoErrorTips;
      if (response.config.disableRepeatRequest) removePending(response.config);

      // 如果失败进行处理
      if (response.headers['trpc-func-ret'] || response.headers['trpc-error-msg']) {
        const errorInfo = httpTrpcStatusHandle(response, autoErrorTips);// 处理trpc错误
        // 上报接口错误
        aegis.reportApiError(`url: ${url} \n\nreq param: ${JSON.stringify(data)} \n\nerror info: ${JSON.stringify(errorInfo)}`);

        return Promise.reject(errorInfo);
      }
      const res = response.config.conciseReturn ? response.data : response;
      // 符合规范的后台 response
      // 通过字段catch判断接口中若启用，默认不进行任何错误处理，交由调用方自行负责；否则用全局错误处理
      if (res.head && res.head.code && Number(res.head.code) !== 0) {
        autoErrorTips && Message({
          type: 'error',
          message: decodeURIComponent(res.head.msg),
        });

        // 上报接口错误
        aegis.reportApiError(`url: ${url} \n\nreq param: ${JSON.stringify(data)} \n\nres data: ${JSON.stringify(res)}`);
      }

      // 白名单用户才上报
      aegis.reportWithWhiteList(`url: ${url} \n\nreq param: ${JSON.stringify(data)} \n\nres data: ${JSON.stringify(res)}`);

      return res || {};
    } catch (e) {
      // -1 表示接口错误
      const errorInfo = new ErrorObject(-1, e.message);
      // 上报接口错误
      aegis.reportApiError(`url: ${url} \n\nreq param: ${JSON.stringify(data)} \n\nerror info: ${JSON.stringify(errorInfo)}`);

      return Promise.reject(errorInfo);
    }
  },
  (error) => {
    const errorInfo = httpErrorStatusHandle(error, error?.config?.autoErrorTips);
    return Promise.reject(errorInfo);
    ;
  }
);

/**
 * 处理options配置
 * @param {*} error
 */
function setOptions(config) {
  const newConfig = config;
  newConfig.headers['pcgec-request-id'] = uuid();
  if (config.data === undefined) config.data = {}; // 设置默认请求数据，否则签名计算会和后端不一致
  newConfig.url = getSignUrl(config); // 添加签名参数，防止请求参数篡改

  const custom_options = Object.assign(
    {
      disableRepeatRequest: true, // 禁止重复请求, 默认为 true
      autoErrorTips: true, // 自动展示错误提示,默认为true
      conciseReturn: true, // 是否开启简洁的数据结构响应, 默认为true
    },
    newConfig,
  );

  return custom_options;
}

/**
 * 生成带签名参数的URL
 * @param {Object} config, 请求配置
 */
function getSignUrl(config) {
  const timestamp = `${Math.round(new Date().getTime() / 1000)}`;
  const sign = md5(`body=${JSON.stringify(config.data)}&timestamp=${timestamp}`);
  const signParams = `sign=${sign}&timestamp=${timestamp}`;
  const newUrl = config.url.includes('?') ? `${config.url}&${signParams}` : `${config.url}?${signParams}`;

  return newUrl;
}


/**
 * 处理trpc错误
 * @param {*} error
 */
function httpTrpcStatusHandle(response, autoErrorTips) {
  let message = response.headers['trpc-func-msg'] || response.headers['trpc-error-msg'] || '未知错误';
  message = decodeURIComponent(message);
  switch (response.headers['trpc-func-ret']) {
    case '401':message = '请求被拒绝';break;
    case '14000':message = '无法获取请求头';break;
    case '14001':message = 'appID为空';break;
    case '14002':message = 'appID未注册';break;
    case '14003':message = 'app_key不匹配';break;
    case '14004':message = '接口配置错误';break;
    case '14005':message = '无该api调用权限';break;
    case '14006':message = '无法获取北极星限流结果';break;
    case '14007':message = '请求被限流';break;
    case '14008':message = '请求无匹配的路由';break;
  }

  const errorInfo = new ErrorObject(response.headers['trpc-func-ret'], message);
  if (autoErrorTips) {
    Message({
      type: 'error',
      message,
    });
  }
  return errorInfo;
}
/**
 * 处理异常
 * @param {*} error
 */
function httpErrorStatusHandle(error, autoErrorTips) {
  // 处理被取消的请求
  if (axios.isCancel(error)) return console.error(`请求的重复请求：${error.message}`);
  let message = '';
  if (error && error.response) {
    switch (error.response.status) {
      case 302: message = '接口重定向了！';break;
      case 400: message = '参数不正确！';break;
      case 401: message = '您未登录，或者登录已经超时，请先登录！';break;
      case 403: message = '您没有权限操作！'; break;
      case 404: message = `请求地址出错: ${error.response.config.url}`; break; // 在正确域名下
      case 408: message = '请求超时！'; break;
      case 409: message = '系统已存在相同数据！'; break;
      case 500: message = '服务器内部错误！'; break;
      case 501: message = '服务未实现！'; break;
      case 502: message = '网关错误！'; break;
      case 503: message = '服务不可用！'; break;
      case 504: message = '服务暂时无法访问，请稍后再试！'; break;
      case 505: message = 'HTTP版本不受支持！'; break;
      default: message = '异常问题，请联系管理员！'; break;
    }
  }
  if (error.message.includes('timeout')) message = '网络请求超时！';
  if (error.message.includes('Network')) message = window.navigator.onLine ? '服务端异常！' : '您断网了！';
  // 设置错误信息
  const errorInfo = new ErrorObject(error && error.response && error.response.status, message);
  if (autoErrorTips) {
    Message({
      type: 'error',
      message,
    });
  }
  return errorInfo;
}

/**
 * 储存每个请求的唯一cancel回调, 以此为标识
 * @param {*} config
 */
function addPending(config) {
  const pendingKey = getPendingKey(config);
  config.cancelToken = config.cancelToken || new axios.CancelToken((cancel) => {
    if (!pendingMap.has(pendingKey)) {
      pendingMap.set(pendingKey, cancel);
    }
  });
}
/**
 * 删除重复的请求
 * @param {*} config
 */
function removePending(config) {
  const pendingKey = getPendingKey(config);
  if (pendingMap.has(pendingKey)) {
    const cancelToken = pendingMap.get(pendingKey);
    cancelToken(pendingKey);
    pendingMap.delete(pendingKey);
  }
}
/**
 * 生成唯一的每个请求的唯一key
 * @param {*} config
 * @returns
 */
function getPendingKey(config) {
  const { url, method, params } = config;
  let {  data } = config;
  if (typeof data === 'string') data = JSON.parse(data); // response里面返回的config.data是个字符串对象
  return [url, method, JSON.stringify(params), JSON.stringify(data)].join('&');
}
export default service;
